export default __webpack_public_path__ + "static/media/yes.641b4d68.wav";